import { ArrowRight } from "lucide-react";
import { trackCtaClick } from "../../lib/ctaTracking";
import { useLanguage } from "../../context/LanguageContext";
import { useHome } from "../../translations/home";

/**
 * Bouton unique du site : réserver la démo de 30 min.
 * `variant` : solid (hero, CTA final, FAQ) ou ghost (sections intermédiaires).
 * Le micro-texte n'apparaît que dans le hero et le CTA final.
 */
export const DemoCTA = ({ from, variant = "solid", tone = "light", align = "center", showSub = false }) => {
  const { language } = useLanguage();
  const c = useHome(language).cta;

  const onClick = () => {
    trackCtaClick(from, language);
    const el = document.getElementById("demo-form");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const dark = tone === "dark";
  const styles =
    variant === "ghost"
      ? dark
        ? "border border-white/40 text-white hover:bg-white/10 hover:border-white"
        : "border border-[#0047AB] text-[#0047AB] hover:bg-cobalt-50"
      : dark
      ? "bg-white text-cobalt-700 hover:bg-cobalt-50 shadow-[0_10px_30px_-10px_rgba(7,42,94,0.6)]"
      : "bg-[#0047AB] text-white hover:bg-[#0B3F8F] shadow-[0_10px_30px_-14px_rgba(0,71,171,0.7)]";

  return (
    <div className={align === "center" ? "text-center" : ""} data-testid={`cta-block-${from}`}>
      <button
        onClick={onClick}
        data-testid={`book-demo-${from}`}
        data-cta-section={from}
        className={`btn-cayus inline-flex items-center gap-2 rounded-md px-7 py-4 font-semibold text-base ${styles}`}
      >
        {c.label}
        <ArrowRight className="btn-arrow w-[18px] h-[18px]" />
      </button>
      {showSub && (
        <p className={`text-sm mt-3 ${dark ? "text-[#CFE6FC]" : "text-[#8A8A8A]"}`} data-testid={`cta-sub-${from}`}>
          {c.sub}
        </p>
      )}
    </div>
  );
};

export default DemoCTA;
